import { api } from '@/services';

export default {
  async fetchUnidadesEscolhidas({ commit }) {
    const response = await api.get('/configuracoes-usuario/filtros');

    commit('SET_UNIDADES_SELECIONADAS', response.data);
  },
  async fetchUnidadesEscolhidasById(_, idUsuario) {
    const response = await api.get(`/configuracoes-usuario/${idUsuario}/filtros`);

    return response.data;
  },
  async salvarUnidadesSelecionadas({ commit, getters }, payload) {
    const unidades = payload.length > 0 ? payload : getters.getUnidadesNegocio;

    await api.post('/configuracoes-usuario/filtros', unidades);

    commit('SET_UNIDADES_SELECIONADAS', unidades);
  },
};
